import React from 'react'
import { Grid } from '@mui/material'
import { Notification, NotificationType } from '../../../redux/notifications/notificationsTypes'
import { TabContent } from './NotificationsComponent'

interface DrawerContentProps {
    handleClickNotificationButton: (
        dataId: string,
        type: NotificationType,
        pageFocus: NotificationType,
        distrib: string,
        notificationId: string,
    ) => void
    handleChange: () => void
    handleArchive: (productId: string, el: any) => void
    notificationsNotArchived: Notification[]
    notificationsArchived: Notification[]
    tabValue: number
}

const DrawerContent = ({
    handleClickNotificationButton,
    notificationsNotArchived,
    notificationsArchived,
    handleArchive,
    tabValue,
}: DrawerContentProps) => {
    return (
        <Grid sx={{ overflowY: 'auto' }}>
            <TabContent
                notifications={notificationsNotArchived}
                handleClickNotificationButton={handleClickNotificationButton}
                handleArchive={handleArchive}
                tabValue={tabValue}
                index={0}
            />
            <TabContent
                index={1}
                notifications={notificationsArchived}
                handleArchive={handleArchive}
                tabValue={tabValue}
            />
        </Grid>
    )
}

export default DrawerContent
